import { useEffect } from "react";
import { RuleRunCriteriaField } from "@rebuild/shared";
import { InputFieldProps } from "./types";
import { GenericRuleRunCriteriaInput } from "../GenericInputComponents";
import { useOrganizations } from "../../../hooks/rebuildBackendFetchHooks";
import { toast } from "react-toastify";

export const OrganizationIdInput: React.FC<InputFieldProps> = ({ inputField, inputValue, onUpdate: _onUpdate }) => {
	if (inputField.type !== "organizations") {
		return <>non-organization types are currently not supported</>;
	}

	const { data: organizations, error } = useOrganizations();

	useEffect(() => {
		if (error) {
			toast.error(error);
		}
	}, [error]);

	// inputValue is now expected to be RuleRunCriteriaList | undefined
	const orgCriteriaList = inputValue as RuleRunCriteriaField | undefined;

	return (
		<GenericRuleRunCriteriaInput
			ruleRunCriteriaList={orgCriteriaList}
			options={organizations}
			getDisplayValue={(organization) => organization?.organizationName ?? ""}
			getObjId={(organization) => organization.organizationId}
			onUpdate={(newValue) => _onUpdate?.(newValue)}
		/>
	);
};
